(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('timeseries', {
            parent: 'entity',
            url: '/timeseries',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseries.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries/timeseries.html',
                    controller: 'TimeseriesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseries');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('timeseries-detail', {
            parent: 'entity',
            url: '/timeseries/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseries.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries/timeseries-detail.html',
                    controller: 'TimeseriesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseries');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Timeseries', function($stateParams, Timeseries) {
                    return Timeseries.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('timeseries.new', {
            parent: 'timeseries',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-dialog.html',
                    controller: 'TimeseriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('timeseries');
                });
            }]
        })
        .state('timeseries.edit', {
            parent: 'timeseries',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-dialog.html',
                    controller: 'TimeseriesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Timeseries', function(Timeseries) {
                            return Timeseries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('timeseries.delete', {
            parent: 'timeseries',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries/timeseries-delete-dialog.html',
                    controller: 'TimeseriesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Timeseries', function(Timeseries) {
                            return Timeseries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
